export default (target, props) => {
  Object.keys(props).forEach(key => {
    const { set, get } = props[key];

    Object.defineProperty(target, key, {
      set(value) {
        target.store.commit(set, value);
      },
      get() {
        return target.store.getters[get];
      }
    });
  });
};
